module.exports = __webpack_public_path__ + "images/questions/qa_balloon_03_84584b7d7bfd5fa3a623e798df45036a.png";